import {Component} from '@angular/core';
import {FormBaseComponent, ValidationPattern, ValidatorService} from '@utils-lib';
import {GrundlageVorauszahlungen} from '@nachdigal';
import {FormBuilder} from '@angular/forms';
import {DatevMessageService} from '@datev/ngx-ui-components';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'common-ui-lib-grundlage-vorauszahlungen',
  templateUrl: './grundlage-vorauszahlungen.component.html',
  styleUrls: ['./grundlage-vorauszahlungen.component.scss']
})
export class GrundlageVorauszahlungenComponent extends FormBaseComponent<GrundlageVorauszahlungen> {

  constructor(private readonly formBuilder: FormBuilder,
              private readonly validatorService: ValidatorService,
              protected readonly messageService: DatevMessageService,
              protected readonly translateService: TranslateService) {
    super(messageService);
  }

  protected createForm(): void {
    const geldBetragInstant = 'COMMON_UI.VALIDATION.GELDBETRAG_PATTERN';
    this.form = this.formBuilder.group({
      steuerpflichtigerJahrBetriebseroeffnung: [
        this.data.steuerpflichtigerJahrBetriebseroeffnung,
        [
          this.validatorService.maxLength(12),
          this.validatorService.pattern(ValidationPattern.VOLLER_GELDBETRAG,
            this.translateService.instant(geldBetragInstant))
        ]],
      ehepartnerJahrBetriebseroeffnung: [
        this.data.ehepartnerJahrBetriebseroeffnung,
        [
          this.validatorService.maxLength(12),
          this.validatorService.pattern(ValidationPattern.VOLLER_GELDBETRAG,
            this.translateService.instant(geldBetragInstant))
        ]],
      steuerpflichtigerFolgejahr: [
        this.data.steuerpflichtigerFolgejahr,
        [
          this.validatorService.maxLength(12),
          this.validatorService.pattern(ValidationPattern.VOLLER_GELDBETRAG,
            this.translateService.instant(geldBetragInstant))
        ]],
      ehepartnerFolgejahr: [
        this.data.ehepartnerFolgejahr,
        [
          this.validatorService.maxLength(12),
          this.validatorService.pattern(ValidationPattern.VOLLER_GELDBETRAG,
            this.translateService.instant(geldBetragInstant))
        ]]
    });
  }
}
